import { Typography } from "@mui/material";
import { TextFieldComponent } from "../../external/ensolvers-core-frontend-mui/components/Common/FormComponents";
import GenericForm from "../../external/ensolvers-core-frontend-mui/components/Common/GenericForm";
import NotificationService from "../../external/ensolvers-core-frontend-mui/submodules/fox-typescript/services/NotificationService";
import { WorklogReportSend } from "../../models/WorklogReportSend";
import WorkLogService from "../../services/WorkLogService";
import ApiErrorUtils from "../../utils/ApiErrorUtils";
import OpsDateUtils from "../../utils/OpsDateUtils";
import { useStyles } from "../Main/formStyles";
import { Token } from "../../theme";

interface Props {
  slackReportDialog?: WorklogReportSend;
  setSlackReportDialog: (newValue: WorklogReportSend | undefined) => void;
}

export const WorklogSlackReport = ({ slackReportDialog, setSlackReportDialog }: Props) => {
  const customStyles = useStyles();

  const handleOnSave = async (data: any) => {
    if (slackReportDialog?.worklog.externalId) {
      if (slackReportDialog.channel === "EXTERNAL") {
        WorkLogService.sendExternalReportToSlack(data.message, slackReportDialog.worklog.externalId)
          .then((response) => response.getContentOrThrowError())
          .then(() => {
            NotificationService.info("Message Sent");
            setSlackReportDialog(undefined);
          })
          .catch((error) =>
            NotificationService.error("Error sending the message: " + ApiErrorUtils.getMessage(error, "Unexpected Error")),
          );
      } else {
        WorkLogService.sendInternalReportToSlack(data.message, slackReportDialog.worklog.externalId)
          .then((response) => response.getContentOrThrowError())
          .then(() => {
            NotificationService.info("Message Sent");
            setSlackReportDialog(undefined);
          })
          .catch((error) =>
            NotificationService.error("Error sending the message: " + ApiErrorUtils.getMessage(error, "Unexpected Error")),
          );
      }
    }
  };

  return (
    <GenericForm
      headerStyles={{ color: Token.textPrimary, marginBottom: -10, marginTop: 10 }}
      buttonStyles={{ marginRight: 20, color: "white", backgroundColor: Token.actionPrimary, marginBottom: 10 }}
      cancelButtonStyles={{
        color: Token.textSecondary,
        border: `1px solid ${Token.borderDefault}`,
        marginBottom: 10,
      }}
      dialogStyles={customStyles.root}
      title={`Confirm Slack Message`}
      onCancel={() => setSlackReportDialog(undefined)}
      dialog
      instance={{ message: slackReportDialog?.reportMsg }}
      dialogCustomSubmitMessage={"Send Message"}
      open={!!slackReportDialog}
      onSave={async (data: any) => handleOnSave(data)}
      renderContent={(register, errors, control) => (
        <>
          <Typography>{`The next message will be sent to the ${slackReportDialog?.channel.toLowerCase()} Project Slack Channel`}</Typography>

          <TextFieldComponent
            register={register}
            errors={errors}
            control={control}
            label={"Slack Report"}
            propertyName={"message"}
            internalProps={{ multiline: true, maxRows: 20 }}
            required={true}
          />

          {slackReportDialog &&
            !OpsDateUtils.isEqualToToday(new Date(slackReportDialog.worklog.shortDay)) &&
            NotificationService.warn("Attention, you are about to send a report for a day that is not the current one")}
        </>
      )}
    />
  );
};
